module.exports = __webpack_public_path__ + "img/meal.03c4bb48.svg";